import { DayLabel, TableContainer } from '@shared/components'
import { useLocales } from '@shared/locales'
import { TableColumnsType, Tag } from 'antd'
import { useState } from 'react'

import { mockPaymentAccounts } from './mockData'
import { PaymentAccountDetailsModal } from './PaymentAccountDetailsModal'
import { PaymentAccount } from './types'

const statusColors: Record<PaymentAccount['status'], string> = {
  paid: 'green',
  unpaid: 'red'
}

const formatPrice = (price: number, currency: string) => {
  return `${price.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })} ${currency}`
}

export const PaymentAccountsCol = () => {
  const [paymentAccounts] = useState<PaymentAccount[]>(mockPaymentAccounts)
  const [selectedPaymentAccount, setSelectedPaymentAccount] =
    useState<PaymentAccount | null>(null)

  const columns: TableColumnsType<PaymentAccount> = [
    {
      title: 'Nr. cont',
      dataIndex: 'account_number',
      key: 'account_number',
      width: 100
    },
    {
      title: 'Data',
      dataIndex: 'date',
      key: 'date',
      width: 120,
      render: (date) => new Date(date).toLocaleDateString('ro-RO')
    },
    {
      title: 'Client',
      dataIndex: 'client_name',
      key: 'client_name'
    },
    {
      title: 'Furnizor',
      dataIndex: 'supplier_name',
      key: 'supplier_name'
    },
    {
      title: 'Total',
      dataIndex: 'total',
      key: 'total',
      width: 150,
      render: (total, record) => formatPrice(total, record.currency)
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      width: 120,
      render: (status: PaymentAccount['status']) => (
        <Tag color={statusColors[status]}>
          {status === 'paid' ? 'Achitat' : 'Neachitat'}
        </Tag>
      )
    },
    {
      title: 'Creat la',
      dataIndex: 'created_at',
      key: 'created_at',
      width: 150,
      render: (created_at) => <DayLabel date={created_at} />
    }
  ]

  return (
    <>
      <TableContainer
        rowKey="id"
        columns={columns}
        dataSource={paymentAccounts}
        loading={false}
        onRow={(record) => ({
          onClick: () => setSelectedPaymentAccount(record),
          style: { cursor: 'pointer' }
        })}
      />

      <PaymentAccountDetailsModal
        open={!!selectedPaymentAccount}
        paymentAccount={selectedPaymentAccount}
        onCancel={() => setSelectedPaymentAccount(null)}
      />
    </>
  )
}
